// NX alert banner (shadcn Alert restyled): info (blue wash), neutral (grey) and attention (red wash) for banners such as read-only mode.
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/cn";

const alertVariants = cva(
  "relative grid w-full grid-cols-[0_1fr] items-start gap-y-0.5 rounded-md border px-3.5 py-3 text-ui has-[>svg]:grid-cols-[18px_1fr] has-[>svg]:gap-x-2.5 [&>svg]:size-[18px] [&>svg]:translate-y-px",
  {
    variants: {
      variant: {
        info: "border-b4 bg-selected text-foreground [&>svg]:text-brand-blue",
        default: "border-border bg-card text-foreground [&>svg]:text-muted-foreground",
        neutral: "border-transparent bg-verdict-grey-bg text-foreground [&>svg]:text-verdict-grey-icon",
        attn: "border-transparent bg-verdict-attn-bg text-foreground [&>svg]:text-verdict-attn-icon",
        destructive: "border-transparent bg-verdict-attn-bg text-foreground [&>svg]:text-verdict-attn-icon",
      },
    },
    defaultVariants: {
      variant: "info",
    },
  },
);

function Alert({
  className,
  variant,
  role = "status",
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
  return (
    <div data-slot="alert" role={role} className={cn(alertVariants({ variant }), className)} {...props} />
  );
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="alert-title" className={cn("col-start-2 font-semibold", className)} {...props} />;
}

function AlertDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-description"
      className={cn("col-start-2 grid justify-items-start gap-1 text-chip text-ink-2 [&_p]:m-0", className)}
      {...props}
    />
  );
}

export { Alert, AlertTitle, AlertDescription, alertVariants };
